import React, { useEffect, useState } from "react";
import "./style.scss";
import {
  MeetingDataType,
} from "../../../redux/clientDirectory/clientDirectoryType";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import {
  getSingleClientMeetUpChecklistAction,
  resetClientDirectoryError,
  resetClientDirectoryFetching,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetSingleClientMeetUpCheklistData,
  updateClientMeetUpChecklistAction,
} from "../../../redux/clientDirectory";
import { RootState } from "../../../redux/rootReducers";
import {
  GetSingleClientMeetUpChecklistPayloadType,
  MeetingChecklistPayload,
} from "../../../commonTypes/clientDirectoryTypes";
import {
  EmptyListPage,
  ErrorSuccessModal,
} from "../../../components/commons";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import ClientMeetUpEditForm from "../../../components/LeadModule/ClientMeetUp/ClientMeetUpEditForm";
import ClientMeetUpHeader from "../../../components/LeadModule/ClientMeetUp/ClientMeetUpHeader";
import { UnauthorizeImage } from "../../../assets/images";

type AppProps = {
  token: null | string;
  history: any;
  fetching: boolean;
  statusCode: number | null;
  message: string | null;
  success: number | null;
  error: null | string;
  loginData: LoginResponseType;
  dispatchResetSession: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetError: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchResetFetching: () => void;
  singleClientMeetUpChecklistData: any;
  dispatchUpdateClientMeetUp: (data: MeetingChecklistPayload) => void;
  dispatchResetSingleClientMeetUpList: () => void;
  dispatchGetSingleClientMeetUpList: (
    data: GetSingleClientMeetUpChecklistPayloadType
  ) => void;
};

const EditClientMeetUpChecklist = ({
  token,
  history,
  loginData,
  fetching,
  statusCode,
  message,
  success,
  error,
  dispatchResetSession,
  dispatchResetSuccess,
  dispatchResetError,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchResetFetching,
  dispatchUpdateClientMeetUp,
  dispatchGetSingleClientMeetUpList,
  dispatchResetSingleClientMeetUpList,
  singleClientMeetUpChecklistData,
}: AppProps) => {
  const client_code = history?.location?.state?.clientCode;
  const sortBy = history?.location?.state?.sortBy;
  const searchData = history?.location?.state?.searchData;
  const meetingFilter= history?.location?.state?.meetingFilter;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [data, setData] = useState<MeetingDataType>({
    meetingDateOfTime: "",
    clientCode: "",
    clientOrOwnerName: "",
    clientFirmOrCompanyName: "",
    state: "",
    country: "",
    city: "",
    scopeOfWork: "",
    turnOverYearly: "",
    numberOfSalesEntries: 0,
    numberOfPurchaseEntries: 0,
    numberOfBankEntries: 0,
    bussinessType: "",
    workingHoursInClientPlace: 0,
    currentDataInWhichSoftware: "",
    remark: "",
    startingMonthOfAccounting: "",
    anyOldWork: "",
    nameOfLeadAssignedByBdTeam: {},
    nameOrSignedOfMeetUpBy: "",
    nameOrSignedOfClient: "",
    meetUpComplete: false,
  });

  const handleInputChange = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    setData({ ...data, [name]: value });
  };

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    dispatchResetSuccess();
    dispatchResetError();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetFetching();
    dispatchResetSingleClientMeetUpList();
  }, []);

  useEffect(() => {
    if (client_code && token) {
      dispatchResetSingleClientMeetUpList();
      let finalData = {
        token,
        clientCode: client_code,
      };

      dispatchGetSingleClientMeetUpList(finalData);
    }
  }, [client_code]);

  useEffect(() => {
    if (singleClientMeetUpChecklistData) {
      let splittedDate=singleClientMeetUpChecklistData?.start_month_of_accounting?.split("-")
      const splittedStartingMonthOfAccounting = splittedDate?.length ? `${splittedDate[1]}-${splittedDate[2]}` : ""
      setData({
        ...data,
        meetingDateOfTime: singleClientMeetUpChecklistData?.meeting_time,
        clientCode: singleClientMeetUpChecklistData?.client_code?.toString(),
        clientOrOwnerName: singleClientMeetUpChecklistData?.name,
        clientFirmOrCompanyName: singleClientMeetUpChecklistData?.company_name,
        country: singleClientMeetUpChecklistData?.country,
        city: singleClientMeetUpChecklistData?.city,
        state: singleClientMeetUpChecklistData?.state,
        scopeOfWork: singleClientMeetUpChecklistData?.scope_of_work,
        turnOverYearly: singleClientMeetUpChecklistData?.turnover_yearly,
        numberOfSalesEntries:
          singleClientMeetUpChecklistData?.number_of_sales_entries,
        numberOfPurchaseEntries:
          singleClientMeetUpChecklistData?.number_of_purchase_entries,
        numberOfBankEntries:
          singleClientMeetUpChecklistData?.number_of_banking_entries,
        bussinessType: singleClientMeetUpChecklistData?.business_type,
        workingHoursInClientPlace:
          +singleClientMeetUpChecklistData?.working_hours_in_client_place,
        currentDataInWhichSoftware:
          singleClientMeetUpChecklistData?.current_software,
        remark: singleClientMeetUpChecklistData?.remarks,
        startingMonthOfAccounting:
          splittedStartingMonthOfAccounting,
        anyOldWork: singleClientMeetUpChecklistData?.old_work,
        nameOfLeadAssignedByBdTeam: singleClientMeetUpChecklistData?.lead_assigned_by,
        meetUpComplete: singleClientMeetUpChecklistData?.meet_up_completed,
      });
    }
  }, [singleClientMeetUpChecklistData]);

  const handleSubmit = () => {
    dispatchResetSingleClientMeetUpList();
    let splittedDate=data?.startingMonthOfAccounting?.split("-");
    let finalData = {
      ...data,
      startingMonthOfAccounting: splittedDate?.length ? `01-${splittedDate[0]}-${splittedDate[1]}` : "",
      clientCode: client_code,
      token,
    };
    dispatchUpdateClientMeetUp(finalData);
    history.push({ pathname: "/lead-module/client-meet-up-check-list",
      state:{
        sortBy,
        searchData,
        meetingFilter
      }
     });
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSuccess();
              dispatchResetError();
              dispatchResetMessage();
              dispatchResetStatusCode();
              dispatchResetFetching();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <div className="client_meet_up_checklist">
      {windowWidth <= 430 ? <div>
        <ClientMeetUpHeader
        handleSubmit={handleSubmit}
        data={data}
        history={history}
        client_code={client_code}
      />

      <div className="client-meet-container">
        <ClientMeetUpEditForm
          data={data}
          setData={setData}
          loginData={loginData}
          handleInputChange={handleInputChange}
        />
      </div>
      </div> : <div className="mt-5">
      <EmptyListPage
        title="Please Login From Mobile Device To Visit This Page"
        image={UnauthorizeImage}
        imageWidth="25%"
      />
    </div>}
      
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  loginData: state.auth.loginData,
  fetching: state.clientDirectory.fetching,
  error: state.clientDirectory.error,
  statusCode: state.clientDirectory.statusCode,
  success: state.clientDirectory.success,
  message: state.clientDirectory.message,
  singleClientMeetUpChecklistData:
    state.clientDirectory.singleClientMeetUpChecklistData,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSuccess: () => dispatch(resetClientDirectorySuccess()),
  dispatchResetError: () => dispatch(resetClientDirectoryError()),
  dispatchResetMessage: () => dispatch(resetClientDirectoryMessage()),
  dispatchResetStatusCode: () => dispatch(resetClientDirectoryStatusCode()),
  dispatchResetFetching: () => dispatch(resetClientDirectoryFetching()),
  dispatchResetSingleClientMeetUpList: () =>
    dispatch(resetSingleClientMeetUpCheklistData()),
  dispatchUpdateClientMeetUp: (data: MeetingChecklistPayload) =>
    dispatch(updateClientMeetUpChecklistAction(data)),
  dispatchGetSingleClientMeetUpList: (
    data: GetSingleClientMeetUpChecklistPayloadType
  ) => dispatch(getSingleClientMeetUpChecklistAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditClientMeetUpChecklist);
